// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabBar_wrapper__xwpu9","item":"TabBar_item__2KiB-","active":"TabBar_active__2wEHW","dark":"TabBar_dark__3NcOH"};